export default __webpack_public_path__ + "static/media/l22-white.11b793c3.svg";